import {BaseFormModel} from './base-form-model';
import {MenuTopping} from './menu-topping';
import {Sortable} from './sortable';
import {MenuItemToppingPrice} from './menu-item-topping-price';

export class MenuItemTopping extends BaseFormModel<MenuItemTopping> implements Sortable {
    id: number;
    included: boolean;
    name: string;
    sortOrder: number;
    topping: MenuTopping;
    prices: MenuItemToppingPrice[];

    init(): void {
        this.topping = !!this.topping && new MenuTopping(this.topping);
    }

    getName() {
        return this.name;
    }
}
